import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  updateUserSubscriptionPlanStart,
  updateUserSubscriptionPlanSuccess,
  updateUserSubscriptionPlanFailed,
  getTierSubscriptionPlansStart,
  getTierSubscriptionPlansSuccess,
  getTierSubscriptionPlansFailed,
  createSubscriptionTierStart,
  createSubscriptionTierSuccess,
  createSubscriptionTierFailed,
  updateSubscriptionTierStart,
  updateSubscriptionTierSuccess,
  updateSubscriptionTierFailed,
  deleteSubscriptionTierStart,
  deleteSubscriptionTierSuccess,
  deleteSubscriptionTierFailed
} from 'redux/actions/user';
import {
  setUsersStart,
  setUsers,
  setUsersFailed,
  getStoresStart,
  getStoresSuccess,
  deleteUserStart,
  deleteUserSuccess,
  deleteUserFailed,
  addUserStoreStart,
  addUserStoreSuccess,
  addUserStoreFailed,
  deleteUserStoreStart,
  deleteUserStoreSuccess,
  deleteUserStoreFailed,
  getStoresFailed,
  deleteStoreStart,
  deleteStoreSuccess,
  deleteStoreFailed,
  addStoreStart,
  addStoreSuccess,
  addStoreFailed,
  saveEditedStoreFailed,
  saveEditedStoreStart,
  saveEditedStoreSuccess,
  getAllPermissionConfigsStart,
  getAllPermissionConfigsSuccess,
  getAllPermissionConfigsFailed,
  createPermissionConfigStart,
  createPermissionConfigSuccess,
  createPermissionConfigFailed,
  updatePermissionConfigStart,
  updatePermissionConfigSuccess,
  updatePermissionConfigFailed,
  deletePermissionConfigStart,
  deletePermissionConfigSuccess,
  deletePermissionConfigFailed,
  createSMUserStart,
  createSMUserSuccess,
  createSMUserFailed,
  getSubscriptionCouponCodesStart,
  getSubscriptionCouponCodesSuccess,
  getSubscriptionCouponCodesFailed,
  createSubscriptionCouponCodeStart,
  createSubscriptionCouponCodeSuccess,
  createSubscriptionCouponCodeFailed,
  updateSubscriptionCouponCodeStart,
  updateSubscriptionCouponCodeSuccess,
  updateSubscriptionCouponCodeFailed,
  deleteSubscriptionCouponCodeStart,
  deleteSubscriptionCouponCodeSuccess,
  deleteSubscriptionCouponCodeFailed,
  getStoreTypeStart,
  getStoreTypeSuccess,
  getStoreTypeFailed,
  getSMReportExportStart,
  getSMReportExportSuccess,
  getSMReportExportFailed,
  getTouchMdUploadsStart,
  getTouchMdUploadsSuccess,
  getTouchMdUploadsFailed,
  getUsersExportStart,
  getUsersExportSuccess,
  getUsersExportFailed
} from 'redux/actions/admin';
import {
  getAuditLogsStart,
  getAuditLogsSuccess,
  getAuditLogsFailed,
  getAuditLogsExportStart,
  getAuditLogsExportSuccess,
  getAuditLogsExportFailed
} from 'redux/actions/audit_logs';
import { parseErrorMessage } from '../helpers/api';


export const getUsersAPI = async ({dispatch, params = '', autocomplete = false}) => {
  try {
    dispatch(setUsersStart());
    const { data } = await api.get(`${shopManagerApi}/users?${params}`);
    dispatch(setUsers(data, autocomplete));
  } catch (e) {
    dispatch(setUsersFailed(e));
  }
};

export const getStoreUsersExportApi = async ({dispatch }) => {
  try {
    dispatch(getUsersExportStart());
    const {data} = await api({
      method: 'get',
      url: `${shopManagerApi}/store-users/download`,
      responseType: 'blob'
    });

    const file = URL.createObjectURL(data);
    window.location.assign(file);

    dispatch(getUsersExportSuccess());
  } catch (e) {
    dispatch(getUsersExportFailed(e));
  }
};

export const getStoresAPI = async ({dispatch, params = ''}) => {
  try {
    dispatch(getStoresStart());
    const { data } = await api.get(`${shopManagerApi}/stores?${params}`);
    dispatch(getStoresSuccess(data));
  } catch (e) {
    dispatch(getStoresFailed(e));
  }
};

export const addUserStoreAPI = async ({dispatch, userEmail, store}) => {
  try {
    dispatch(addUserStoreStart());
    await api.post(`${shopManagerApi}/user/stores`, {email: userEmail, apiUrl: store.apiUrl});
    dispatch(addUserStoreSuccess({userEmail, store}));
  } catch (e) {
    dispatch(addUserStoreFailed(e));
  }
};

export const deleteUserStoreAPI = async ({dispatch, apiUrl, email}) => {
  try {
    dispatch(deleteUserStoreStart());
    const { data } = await api.delete(`${shopManagerApi}/user/stores/`, { data: {apiUrl, email}});
    dispatch(deleteUserStoreSuccess({apiUrl, email, data}));
  } catch (e) {
    dispatch(deleteUserStoreFailed(e));
  }
};

export const deleteUserAPI = async ({dispatch, email}) => {
  try {
    dispatch(deleteUserStart());
    await api.delete(`${shopManagerApi}/users/${email}`);
    dispatch(deleteUserSuccess(email));
  } catch (e) {
    dispatch(deleteUserFailed(e));
  }
};

export const addStoreAPI = async ({dispatch, store}) => {
  try {
    dispatch(addStoreStart());
    const { data } = await api.post(`${shopManagerApi}/store/`, store);
    dispatch(addStoreSuccess(store, data));
  } catch (e) {
    dispatch(addStoreFailed(e));
  }
};

export const deleteStoreAPI = async ({dispatch, url, id}) => {
  try {
    dispatch(deleteStoreStart());
    const { data } = await api.delete(`${shopManagerApi}/stores/${encodeURIComponent(url)}`);
    dispatch(deleteStoreSuccess(id, data));
  } catch (e) {
    dispatch(deleteStoreFailed(e));
  }
};

export const saveEditedStoreAPI = async (dispatch, store) => {
  try {
    dispatch(saveEditedStoreStart());
    const { data } = await api.patch(`${shopManagerApi}/stores/${store._id}`, store);
    dispatch(saveEditedStoreSuccess(data));
  } catch (e) {
    dispatch(saveEditedStoreFailed(e));
  }
};

export const getStoreTypeApi = async ({dispatch}) => {
  try {
    dispatch(getStoreTypeStart());
    const {data} = await api.get(`${shopManagerApi}/store/configs?configs[]=theme_settings/store/store_type`);
    dispatch(getStoreTypeSuccess(data));
  } catch (e) {
    dispatch(getStoreTypeFailed(e));
  }
};

export const getAllPermissionConfigsApi = async ({dispatch}) => {
  try {
    dispatch(getAllPermissionConfigsStart());
    const { data } = await api.get(`${shopManagerApi}/admin/configs`);
    dispatch(getAllPermissionConfigsSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(getAllPermissionConfigsFailed(message));
  }
};

export const createPermissionConfigApi = async ({dispatch, permissionConfig}) => {
  try {
    dispatch(createPermissionConfigStart());
    const { data } = await api.post(`${shopManagerApi}/admin/config`, permissionConfig);
    dispatch(createPermissionConfigSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(createPermissionConfigFailed(message));
  }
};

export const updatePermissionConfigApi = async ({dispatch, permissionConfig}) => {
  try {
    dispatch(updatePermissionConfigStart());
    const { data } = await api.patch(`${shopManagerApi}/admin/config/${permissionConfig._id}`, permissionConfig);
    dispatch(updatePermissionConfigSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(updatePermissionConfigFailed(message));
  }
};

export const deletePermissionConfigByIdApi = async ({dispatch, id}) => {
  try {
    dispatch(deletePermissionConfigStart());
    const { data } = await api.delete(`${shopManagerApi}/admin/config/${id}`);
    dispatch(deletePermissionConfigSuccess(id, data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(deletePermissionConfigFailed(message));
  }
};

export const getAuditLogsApi = async ({dispatch, page = '1', limit = '10', sortField = 'createdAt', sortDir = 'desc', email = '', fromDate = '', toDate = '', store = '', action = '', reqBody = ''}) => {
  try {
    dispatch(getAuditLogsStart());
    const params = new URLSearchParams({
      email,
      fromDate,
      toDate,
      store,
      sortField,
      sortDir,
      skipGetRequests: '1',
      page,
      limit,
      action,
      reqBody
    }).toString();
    const { data } = await api.get(`${shopManagerApi}/admin/request-logs?${params}`);
    dispatch(getAuditLogsSuccess(data));
  } catch (e) {
    dispatch(getAuditLogsFailed(e));
  }
};

export const exportAuditLogsApi = async ({dispatch, email = '', fromDate = '', toDate = '', store = '', action = '', reqBody = ''}) => {
  try {
    dispatch(getAuditLogsExportStart());

    const params = new URLSearchParams({
      email,
      fromDate,
      toDate,
      store,
      skipGetRequests: '1',
      action,
      reqBody
    }).toString();

    const {data} = await api({
      method: 'get',
      url: `${shopManagerApi}/admin/request-logs/export?${params}`,
      responseType: 'blob'
    });

    const file = URL.createObjectURL(data);
    window.location.assign(file);

    dispatch(getAuditLogsExportSuccess(data));
  } catch (e) {
    dispatch(getAuditLogsExportFailed(e));
  }
};

export const exportSMReportApi = async ({ dispatch, fromDate = '', toDate = '' }) => {
  try {
    dispatch(getSMReportExportStart());

    const params = new URLSearchParams({
      fromDate,
      toDate,
      skipGetRequests: '1'
    }).toString();

    const {data} = await api({
      method: 'get',
      url: `${shopManagerApi}/admin/sm-report/export?${params}`,
      responseType: 'blob'
    });

    const file = URL.createObjectURL(data);
    window.location.assign(file);

    dispatch(getSMReportExportSuccess(data));
  } catch (e) {
    dispatch(getSMReportExportFailed(e));
  }
};

export const getTierSubscriptionPlansApi = async ({dispatch}) => {
  try {
    dispatch(getTierSubscriptionPlansStart());
    const {data} = await api.get(`${shopManagerApi}/subscription/tiers`);
    dispatch(getTierSubscriptionPlansSuccess(data));
  } catch (e) {
    dispatch(getTierSubscriptionPlansFailed(e));
  }
};

export const createSubscriptionTierApi = async ({ dispatch, tier}) => {
  try {
    dispatch(createSubscriptionTierStart());
    const {data} = await api.post(`${shopManagerApi}/subscription/tier`, tier);
    dispatch(createSubscriptionTierSuccess(data));
  } catch (e) {
    dispatch(createSubscriptionTierFailed(e));
  }
};

export const updateSubscriptionTierApi = async ({ dispatch, tier}) => {
  try {
    dispatch(updateSubscriptionTierStart());
    const {data} = await api.patch(`${shopManagerApi}/subscription/tier`, tier);
    dispatch(updateSubscriptionTierSuccess(data));
  } catch (e) {
    dispatch(updateSubscriptionTierFailed(e));
  }
};

export const deleteSubscriptionTierApi = async ({ dispatch, id}) => {
  try {
    dispatch(deleteSubscriptionTierStart());
    const {data} = await api.delete(`${shopManagerApi}/subscription/tier/${id}`);
    dispatch(deleteSubscriptionTierSuccess(data, id));
  } catch (e) {
    dispatch(deleteSubscriptionTierFailed(e));
  }
};

export const updateUserSubscriptionPlanApi = async ({ dispatch, usersToUpdate}) => {
  try {
    dispatch(updateUserSubscriptionPlanStart());
    const promises = usersToUpdate.map((user) => api.patch(`${shopManagerApi}/subscription/tier/assign-store`, user));
    const results = await Promise.allSettled(promises);
    dispatch(updateUserSubscriptionPlanSuccess(results, usersToUpdate));
  } catch (e) {
    dispatch(updateUserSubscriptionPlanFailed(e));
  }
};

export const createSMUserApi = async ({dispatch, user}) => {
  try {
    dispatch(createSMUserStart());
    const { data } = await api.post(`${shopManagerApi}/users`, user);
    dispatch(createSMUserSuccess(data));
  } catch (e) {
    dispatch(createSMUserFailed(e));
  }
};


export const getSubscriptionCouponCodesApi = async ({dispatch}) => {
  try {
    dispatch(getSubscriptionCouponCodesStart());
    const {data} = await api.get(`${shopManagerApi}/subscription/referral-codes`);
    dispatch(getSubscriptionCouponCodesSuccess(data));
  } catch (e) {
    dispatch(getSubscriptionCouponCodesFailed(e));
  }
};

export const createSubscriptionCouponCodeApi = async ({dispatch, codeData}) => {
  try {
    dispatch(createSubscriptionCouponCodeStart());
    const {data} = await api.post(`${shopManagerApi}/subscription/referral-codes`, codeData);
    dispatch(createSubscriptionCouponCodeSuccess(data));
  } catch (e) {
    dispatch(createSubscriptionCouponCodeFailed(e));
  }
};

export const updateSubscriptionCouponCodeApi = async ({dispatch, id, codeData}) => {
  try {
    dispatch(updateSubscriptionCouponCodeStart());
    const {data} = await api.patch(`${shopManagerApi}/subscription/referral-codes/${id}`, codeData);
    dispatch(updateSubscriptionCouponCodeSuccess(data));
  } catch (e) {
    dispatch(updateSubscriptionCouponCodeFailed(e));
  }
};

export const deleteSubscriptionCouponCodeApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteSubscriptionCouponCodeStart());
    await api.delete(`${shopManagerApi}/subscription/referral-codes/${id}`);
    dispatch(deleteSubscriptionCouponCodeSuccess(id));
  } catch (e) {
    dispatch(deleteSubscriptionCouponCodeFailed(e));
  }
};

export const getTouchMdUploadsAPI = async ({
  dispatch,
  page,
  limit,
  email
}) => {
  try {
    const params = new URLSearchParams({
      page,
      limit,
      email
    }).toString();
    dispatch(getTouchMdUploadsStart());
    const { data } = await api.get(`${shopManagerApi}/touchmd/uploads?${params}`);
    dispatch(getTouchMdUploadsSuccess(data));
  } catch (e) {
    dispatch(getTouchMdUploadsFailed(e));
  }
};
